<template>
    <DModal
        :title="__('tools.partners.uploads.modals.upload_file.title')"
        is-big
        :show="showModal || modalHasErrors || modalPreviewData"
        :is-awaiting-validation="true"
        close-color-secondary
        @close="$emit('close-modal')"
        @clearFields="resetForm()"
    >
        <DCard
            class="border border-0 p-2"
            padding
        >
            <DFormRow
                :label="__('tools.partners.uploads.modals.upload_file.file')"
                is-required
                :error="errors.file"
                :hint="form.file ? form.file.name : ''"
            >
                <DFileInput
                    id="file"
                    :custom="true"
                    :multiple="false"
                    @change="addFile"
                />
            </DFormRow>
            <DFormRow
                v-if="previewData"
                :label="__('tools.partners.uploads.modals.upload_file.overview')"
            >
                <DTable
                    :items="previewData.data"
                    :fields="previewTableFields"
                />
            </DFormRow>
            <DFormRow
                v-if="errors && errors.errorsData"
                :label="''"
            >
                <p class="error-header">
                    {{ __('tools.partners.uploads.modals.upload_file.errors') }}
                </p>
                <ul class="p-0">
                    <li
                        v-for="(error, index) in errors.errorsData"
                        :key="index"
                        class="error-body"
                    >
                        {{ error }}
                    </li>
                </ul>
            </DFormRow>
        </DCard>
        <template #actions>
            <DButton
                v-if="form.save === false"
                :label="__('messages.preview')"
                :disabled="isInLoadingState"
                :loading="isInLoadingState"
                color="primary"
                @click="preview"
            />
            <DButton
                v-else
                :label="__('messages.upload')"
                :disabled="isInLoadingState"
                :loading="isInLoadingState"
                class="ms-1"
                color="success"
                @click="save"
            />
        </template>
    </DModal>
</template>

<script>

export default {
    name: 'UploadFileModal',
    props: {
        showModal: {
            type: Boolean,
            default: false
        }
    },
    emits: ['close-modal'],
    data () {
        return {
            form: this.$inertia.form({
                file: null,
                save: false
            }),
            errors: [],
            modalHasErrors: false,
            modalPreviewData: false,
            previewData: null,
            previewTableFields: []
        }
    },
    methods: {
        preview () {
            let formData = null
            if (this.form.file !== null) {
                formData = new FormData()
                formData.append('file', this.form.file)
            }

            window.axios.post(this.$route('tools.partners.file-preview'),
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
                .then((response) => {
                    this.previewData = response.data
                    this.form.save = true
                    this.modalPreviewData = true
                    this.errors = {}
                    this.modalHasErrors = false
                    this.setPreviewTableFields()
                })
                .catch((error) => {
                    if (error && error.response && error.response.data.errors !== undefined) {
                        this.errors = error.response.data.errors

                        for (const key in this.errors) {
                            if (typeof this.errors[key] === 'object') {
                                this.errors[key] = this.errors[key][0]
                            }
                        }

                        this.modalHasErrors = true
                    }
                })
        },
        setPreviewTableFields () {
            this.previewTableFields = [
                { key: 'id', label: this.__('tools.partners.uploads.modals.upload_file.table.distributor_id') },
                { key: 'name', label: this.__('tools.partners.uploads.modals.upload_file.table.distributor_name') }
            ]

            for (const [key] in this.previewData.monthsForPreview) {
                const month = this.previewData.monthsForPreview[key]
                this.previewTableFields.push({ key: month, label: this.__('tools.partners.uploads.modals.upload_file.table.' + month) })
            }
        },
        save () {
            this.form.post(this.$route('tools.partners.partner-uploads.store'),
                {
                    onSuccess: () => {
                        this.$emit('close-modal')
                        this.resetForm()
                    },
                    onError: (error) => {
                        this.errors = error
                        this.modalHasErrors = true
                        this.previewData = null
                        this.form.save = false
                    }
                })
        },
        resetForm () {
            this.form.file = null
            this.form.save = false
            this.modalHasErrors = false
            this.modalPreviewData = false
            this.previewData = null
            this.previewTableFields = []
            this.errors = []
        },
        addFile (fileList) {
            this.form.file = fileList[0]
            this.form.save = false
            this.modalHasErrors = false
            this.modalPreviewData = false
            this.previewData = null
            this.previewTableFields = []
            this.errors = []
        }
    }
}
</script>

<style scoped>
.error-header {
    font-weight: bold;
    padding: 10px;
    margin-bottom: 0;
    border-top: 2px solid rgba(0,0,0,0.07);
    border-bottom: 2px solid rgba(0,0,0,0.07);
}
.error-body {
    padding: 10px;
    border-bottom: 2px solid rgba(0,0,0,0.07);
}
</style>
